/*
 * @author: wayou
 * @date: 2018-08-28 12:12:54
 * @description: 简单的土司
 */

import './toast.scss';

interface IToastOptions {
    style?: string;
    class?: string;
    message: string | number;
    duration?: number;
    animationDuration?: number | string;
    callback?: () => void;
}

export default class Toast {
    /**
     * 展示土司
     *
     * @static
     * @param {string} message 需要展示的消息文本
     * @memberof Toast
     */
    public static show(message: string): void;
    /**
     * 展示土司，自定义展示的表现
     *
     * @static
     * @param {IToastOptions} options 土司参数
     * @memberof Toast
     */
    public static show(options: IToastOptions): void;
    public static show(options: string | IToastOptions) {
        let toastOption: IToastOptions = Object.assign({}, this.defaultOptions, options);
        if (typeof options === 'string') {
            toastOption = Object.assign({}, this.defaultOptions, { message: options });
        } else {
            toastOption = Object.assign({}, this.defaultOptions, options);
        }
        let element = document.getElementById(`toast`);
        if (this.timer) {
            window.clearTimeout(this.timer);
            this.timer = null;
            this._hide(element);
        }
        if (!element) {
            element = this.create(toastOption);
        } else {
            this.applyOption(element, toastOption);
        }

        this._show(element);
        this.timer = window.setTimeout(() => {
            this._hide(element);
            if (typeof options === 'string') {
                return;
            }
            if (typeof options?.callback === 'function') {
                options.callback();
            }
        }, toastOption.duration);
    }

    public static hide() {
        const element = document.getElementById(`toast`);
        if (!element) {
            return;
        }
        if (this.timer) {
            window.clearTimeout(this.timer);
            this.timer = null;
        }
        this._hide(element);
    }

    private static defaultOptions: IToastOptions = {
        duration: 3000,
        message: '',
        class: '',
        style: '',
        animationDuration: '0.5s',
    };

    private static timer: number | null = null;

    /**
     * 每次展示时重新运用土司参数，因为每次展示时不同调用地方可传递不同参数
     * 但土司全局只有一个
     * @param element 土司根节点
     * @param toastOption 土司参数
     */
    private static applyOption(element: HTMLElement, toastOption: IToastOptions) {
        element.className = `${toastOption.class}`;
        // tslint:disable-next-line:max-line-length
        element.style.cssText = `${toastOption.style};transition: visibility 0s, opacity ${toastOption.animationDuration} linear;`;
        element.innerHTML = (
            `
            ${toastOption.message}
            ` || ''
        ).trim();
    }

    /**
     * 创建土司元素
     * @param toastOption 土司参数
     */
    private static create(toastOption: IToastOptions): HTMLElement {
        const element = document.createElement('div');
        element.setAttribute('id', 'toast');
        this.applyOption(element, toastOption);
        document.body.appendChild(element);
        return element;
    }

    /**
     * 设置 `show` className 以展示土司
     * @param element 土司根节点
     */
    private static _show(element: HTMLElement | null) {
        if (element) {
            element.className += ' show';
        }
    }

    /**
     * 移除 `show` clasName 以隐藏土司
     * @param element 土司根节点
     */
    private static _hide(element: HTMLElement | null) {
        if (element) {
            element.className = element.className.replace('show', '');
        }
    }
}
